var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-badge',{staticClass:"score",attrs:{"pill":"","color":_vm.getColorByScore(_vm.score)}},[_c('strong',[_vm._v(_vm._s(_vm.getGradeByScore(_vm.score)))])])}
var staticRenderFns = []

export { render, staticRenderFns }